
import React, { useState } from "react";
import { Control } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

interface PasswordFieldProps {
  control: Control<any>;
  name: string;
  label: string;
  placeholder: string;
  autoComplete: string;
  required?: boolean;
  helpText?: string;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  control,
  name,
  label,
  placeholder,
  autoComplete,
  required = false,
  helpText
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel required={required}>{label}</FormLabel>
          <FormControl>
            <div className="relative">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                autoComplete={autoComplete}
                className="h-11 pr-10"
                {...field}
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </FormControl>
          {helpText && <div className="text-xs text-gray-500 mt-1">{helpText}</div>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default PasswordField;

